import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ThemeModeProvider } from '@/theme/ThemeModeContext';
import { queryClient } from '@/api/queryClient';
import QueryFailureBanner from '@/components/QueryFailureBanner';
// Must be imported before the first render so <html dir|lang> and t() are ready.
import '@/i18n';
import App from './App';
import { installChunkReloadHandler } from '@/utils/lazyWithReload';

// A tab left open across a deploy requests asset filenames that no longer
// exist. Recover by reloading once rather than showing a blank page.
installChunkReloadHandler();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeModeProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          {/*
            Deliberately WITHOUT `future={{ v7_startTransition: true }}`.
            With it, a navigation renders after any store update made in the
            same click, so handlers that switch business AND navigate (the
            sidebar's "back to agency", the top bar's settings shortcut) ran
            effects on the old page with the new business — e.g. RequireBusiness
            re-selected the business the user had just left. Enable it only
            after those handlers are reworked and tested.
          */}
          <BrowserRouter>
            <App />
            {/* Catches any request that fails without a local handler, so a
                failed load can never render as "you have no data". See
                api/queryClient.js. */}
            <QueryFailureBanner />
          </BrowserRouter>
        </LocalizationProvider>
      </ThemeModeProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
